import { defineStore } from "pinia";
import { gender } from "../composables/aboutYou";
import { PersonData } from "../entities/conditions";

export enum Title {
    Mr = "Mr",
    Miss = "Miss",
    Mrs = "Mrs",
    Ms = "Ms",
    Sir = "Sir",
    DrMale = "Dr (Male)",
    DrFemale = "Dr (Female)",
}

export enum MaritalStatus {
    Single = "Single",
    Married = "Married",
    Separated = "Separated",
    Divorced = "Divorced",
    Widowed = "Widowed",
    CivilPartnership = "Civil Partnership",
    DissolvedCivilPartnership = "Dissolved Civil Partnership",
    Cohabiting = "Cohabiting",
    SurvivingCivilPartnership = "Surviving Civil Partnership",
}

export enum Gender {
    Male = "male",
    Female = "female",
}

export type YourDetailsStorePartial = {
    title: Title | null | undefined,
    forename: string,
    surname: string,
    dob: string,
    email: string,
    phone: string,
    maritalStatus: MaritalStatus | null | undefined,
    postcode: string,
    sex: Gender | null | undefined,
}

export type YourDetailsStore = {
    quoteLoaded?: boolean,
    title: Title | null,
    forename: string,
    surname: string,
    dob: string,
    email: string,
    phone: string,
    maritalStatus: MaritalStatus | null,
    postcode: string,
    sex: Gender | null,
}

export const useYourDetailsStore = defineStore("yourDetails", {
    state: () : YourDetailsStore => {
        return {
            quoteLoaded: false,
            title: null,
            forename: "",
            surname: "",
            dob: "",
            email: "",
            phone: "",
            maritalStatus: null,
            postcode: "",
            sex: null,
        };
    },
    getters: {
        dobYear: (state: YourDetailsStore) => Number(state.dob.split("-")[0]),
        getCustomerDetails: (state) => {
            return {
                title: state.title,
                forename: state.forename,
                surname: state.surname,
                email: state.email || "",
                dob: state.dob,
                sex: state.sex ?? gender(state.title),
                phone: state.phone ? state.phone : null,
                maritalStatus: state.maritalStatus,
                address: {
                    line1: null,
                    line2: null,
                    city: null,
                    county: null,
                    postcode: state.postcode,
                },
            };
        },
        isOnlineCustomer: (state) => {
            if (
                state.email === null ||
                state.email === "" ||
                state.email === undefined ||
                state.email.includes("annuityready.com")) {
                return false;
            } else {
                return true;
            }
        },
        getPersonDataForMedical: (state): PersonData => ({
            dob: state.dob,
        }),
    },
});
